import Cookies from "js-cookie";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { handlingApi } from "units/handlingApi";

const AdminLogin = () => {
  const [adminLogin, setAdminLogin] = React.useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const adminToken = Cookies.get("adminToken");

  useEffect(() => {
    if (adminToken) {
      navigate("/admin/dashboard");
    }
  }, []);

  const handleAdminLoin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}user/admin-signin`;
      const res = await handlingApi({ url, method: "POST", data: adminLogin });

      if (res.statusCode === 200) {
        toast.success(res.message);
        // console.log("res", res.adminToken);
        Cookies.set("adminToken", res.adminToken);
        localStorage.setItem("adminUserData", JSON.stringify(res.userData));
        navigate("/admin/dashboard");
        setLoading(false);
        setAdminLogin({ email: "", password: "" });
      }

      if (res.statusCode === 403 || res.statusCode === 400) {
        toast.error(res.message);
        setLoading(false);
      }
    } catch (error: any) {
      toast.error(error.message);
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex align-items-center justify-content-center"
    >
      <div className="form-wrapper">
        <div id="logo">
          <h3>Admin Login</h3>
        </div>

        <h5>Sign in</h5>

        <form onSubmit={handleAdminLoin}>
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              placeholder="Enter Email"
              required
              value={adminLogin.email}
              onChange={(e) =>
                setAdminLogin({ ...adminLogin, email: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              className="form-control"
              placeholder="Enter Password"
              required
              value={adminLogin.password}
              onChange={(e) =>
                setAdminLogin({ ...adminLogin, password: e.target.value })
              }
            />
          </div>
          <div className="form-group d-flex justify-content-between ps-3">
          </div>
          <button
            style={{ borderRadius: "10px" }}
            className={`btn btn-primary py-3 fs-4 ${loading ? "bg-transparent" : ""}`}
          >
            {loading ? <ClipLoader size={20} color="#00308f" /> : "Sign In"}
          </button>
          <hr />
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
